const AUTH_KEY = 'cm.auth'

export type CmAuth = { mode: 'bearer'; accessToken: string }

export function readAuth(): CmAuth | null {
  try {
    const raw = window.sessionStorage.getItem(AUTH_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as { mode?: string; accessToken?: string }
    if (parsed?.mode === 'bearer' && typeof parsed.accessToken === 'string' && parsed.accessToken) {
      return { mode: 'bearer', accessToken: parsed.accessToken }
    }
    return null
  } catch {
    return null
  }
}

export function writeAuth(auth: CmAuth): void {
  window.sessionStorage.setItem(AUTH_KEY, JSON.stringify(auth))
}

export function clearAuth(): void {
  window.sessionStorage.removeItem(AUTH_KEY)
}

export function authHeaders(auth: CmAuth | null = readAuth()): HeadersInit {
  if (!auth) return {}
  return { Authorization: `Bearer ${auth.accessToken}` }
}
